import {ApiClient} from "./config";

export const getReferralLinkReq = async () => {
    return await ApiClient.get(`api/v1/referrals/my-link/`);
}